import { createContext } from 'react';
import type { TableInstance } from 'react-table';

const TableInstanceContext = createContext<TableInstance<any>>(null);

export default TableInstanceContext;
